module.exports = __webpack_public_path__ + "img/menu.42c4d865.svg";